import { RecentBoardsSection } from "./Board/RecentBoardSection.tsx";
import { InspirationLibrarySection } from "./InspirationLibrary/InspirationLibrarySection.tsx";
import { QuickActionsSection } from "./QuickActionsSection.tsx";

export const HomeIndex = () => (
  <div className="h-full w-full p-800 flex-col overflow-y-auto gap-400">
    <QuickActionsSection />
    <RecentBoardsSection />
    <InspirationLibrarySection />
  </div>
);
